import { render, staticRenderFns } from "./WidgetTableLayout.vue?vue&type=template&id=8f3a6a82&scoped=true&"
import script from "./WidgetTableLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetTableLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTableLayout.vue?vue&type=style&index=0&id=8f3a6a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3a6a82",
  null
  
)

export default component.exports